'use client';
import { useEffect } from 'react';
import { Button } from '@/components/ui';
import { useAnalytics } from '@/contexts/AnalyticsContext';
import { LMS_EVENTS } from '@/lib/analytics';

export default function CoursesError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { track } = useAnalytics();

  useEffect(() => {
    console.error(error);
    track(LMS_EVENTS.ERROR_BOUNDARY_TRIGGERED, {
      errorMessage: error.message,
      location: 'courses',
    });
  }, [error]);
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="bg-red-50 border border-red-100 rounded-2xl p-8 text-center space-y-4 max-w-md">
        <p className="text-red-600 font-medium">{error.message || 'Something went wrong.'}</p>
        <Button onClick={reset} variant="primary">
          Try Again
        </Button>
      </div>
    </div>
  );
}
